
<!--start section header-->
 
<header class="head">
    <div class="cover">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5">
                 About
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">About</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->

 <!--start section Our Site-->


<section class="container py-5">

    <div class="text-center section-header">
      <h2 class="pt-5 pb-2">Welcome to Our Site!</h2>
      <p class="pb-3 text-muted">We are a biopharmaceutical company focused on the discovery, development and commercialization of <br>
         innovative therapies intended to improve outcomes in patients sufferings
      </p>
    </div>
    <div class="row">
  
      <div class="col-lg-4 col-md-6">
        <div class="text-center py-5 border mb-3">
          <i class="far fa-user fa-3x pb-3"></i>
          <h4 class="pb-3">Pharma Team</h4>
          <p class="pb-5 text-muted">Company was founded by scientists <br> dedicated to create new therapeutics.</p>
          <button class="btn btn-outline-danger  py-2" >Our Team</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="text-center py-5 border mb-3">
          <i class="far fa-lightbulb fa-3x pb-3"></i>
          <h4 class="pb-3">Pharma Focus</h4>
          <p class="pb-5 text-muted">We Interrogate the inner life of GPCR <br> signaling to develop newest.</p>
          <button class="btn btn-outline-danger py-2 bg" >Discover Now</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 center-content">
        <div class="text-center py-5 border mb-3">
          <i class="far fa-paper-plane fa-3x pb-3"></i>
          <h4 class="pb-3">Pharma Pipeline</h4>
          <p class="pb-5 text-muted">Consetetur sadipscing elitr sediam <br> nonumy eirmod tempor invidunt labore.</p>
          <button class="btn btn-outline-danger  py-2" >Check it</button>
        </div>
      </div>
  
    </div>
  
  </section>
  
  <!--end section Our Site-->

  <!--start section testimonials-->
   <section class="testimonials">
    <div class="parallax" data-parallax="scroll">

     <div class="container py-5">
       <div class="d-flex justify-content-center text-white test-head py-5">
         <h2>
          Client Testimonials
         </h2>
       </div>
     
        <div data-slick='{"slidesToShow": 3, "slidesToScroll": 3}' class="slider  d-flex justify-content-center">
          <div>
            <div class="card text-center" style="width: 18rem;">
              <img src="assets/images/1.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Heidi J. Cobb
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card colors-body" style="width: 18rem;">
              <img src="assets/images/3.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Felicia L. Brooks
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card" style="width: 18rem;">
              <img src="assets/images/5.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Frank C. McGee
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card" style="width: 18rem;">
              <img src="assets/images/1.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Heidi J. Cobb
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card colors-body" style="width: 18rem;">
              <img src="assets/images/3.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Felicia L. Brooks
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          <div>
            <div class="card" style="width: 18rem;">
              <img src="assets/images/5.jpg" class="card-img-top" alt="doctor">
              <div class="card-body">
                <p class="card-text"> Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam.
                </p>
                <h5>
                  Frank C. McGee
                </h5>
                <p>Customer</p>
              </div>
            </div>
          </div>
          
          
        </div>
      
     </div>
    
    
    </div>

   </section>
    
   <!--end section testimonials-->


   
  <!--start section why choose-->

  <section class="container py-5">
    <div class="row py-5">
       
      <div class="col-lg-4 col-md-12 pb-4">
        <div class="choose-content content-width">
          <h3 class="font-weight-bold pb-4">
           Why Choose Us?
          </h3>
          <button class="btn btn-outline-danger py-2" >About Us</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 pb-3">
       <div class="media choose-content pb-4">
         <i class="far fa-gem mr-3"></i>
         <div class="media-body">
           <h5 class="mt-0">Newest Technologies</h5>
           <p>Consetetur sadipscing elitr diam nonumy eirmod tempor invidunt.</p>
         </div>
       </div>
       <div class="media choose-content">
         <i class="fas fa-cloud mr-3"></i>
         <div class="media-body">
           <h5 class="mt-0">Taking Care of Nature</h5>
           <p>Ut labore et dolore magna aliquyam erat sed diam voluptua.</p>
         </div>
       </div>
     </div>


     <div class="col-lg-4 col-md-6 ">
       <div class="media choose-content pb-4">
         <i class="fas fa-tag mr-3"></i>
         <div class="media-body">
           <h5 class="mt-0">Fair Prices</h5>
           <p>At vero eos et accusam ejusto duo dolores et ea rebum clita gubergren.</p>
         </div>
       </div>
       <div class="media choose-content">
         <i class="fas fa-cloud mr-3"></i>
         <div class="media-body">
           <h5 class="mt-0">High Customer Satisfaction</h5>
           <p>Nosea takimata sanctus est lorem ipsum dolor sit amet.</p>
         </div>
       </div>
     </div>
      

          






    </div>
  </section>


 <!--end section why choose-->

 <!--start section progress-->
    
 <section class="progress py-4">
    <div class="container py-4">
      <div class="row">

        <div class="col-lg col-md-6">
          <div class="one circle">
            <strong></strong>
            <p class="pt-4 p1">Years Experience</p>
          </div>
        </div>
        <div class="col-lg col-md-6">
          <div class="second circle">
            <strong></strong>
            <p class="pt-4 p2">Medicament Invented</p>
          </div>
        </div>
        <div class="col-lg col-md-6">
          <div class="thrid circle">
            <strong></strong>
            <p class="pt-4 p3">Awards Winned</p>
          </div>
        </div>
        <div class="col-lg col-md-6">
          <div class="four circle">
            <strong></strong>
            <p class="pt-4 p4">Happy Clients</p>
          </div>
        </div>
        <div class="col-lg col-md-6">
          <div class="five circle">
            <strong></strong>
            <p class="pt-4 p5">Pharmacies Partners</p>
          </div>
        </div>








      </div>
    </div>
  </section>
 
<!--end section progress-->